import { useEffect, useRef } from 'react'

import { useCorporateEnrollment } from '@/hooks/useCorporateEnrollment'
import type { CorporateEnrollment } from '@/utils/corporateResume'

export const useEnrollmentHydration = (
  hydrate: (enrollment: CorporateEnrollment) => void
) => {
  const { data: enrollment, isLoading } = useCorporateEnrollment(true)
  const hydrated = useRef(false)

  useEffect(() => {
    if (hydrated.current || !enrollment) return
    hydrated.current = true
    hydrate(enrollment)
  }, [enrollment, hydrate])

  return { enrollment, isLoading }
}
